import { TPaymentPlansResponse } from '@onesource/schemas';
import { useQuery } from '@tanstack/react-query';

import axios from '../axios';

const ENTITY = 'billing';

export const getMemberPaymentPlansQueryKey = (page: number, perPage: number) => [
  ENTITY,
  'payment-plans',
  page,
  perPage,
];

export const useGetMemberPaymentPlansQuery = (params: { page?: number; perPage?: number; enabled?: boolean }) => {
  const { page = 1, perPage = 10, enabled = true } = params;

  return useQuery<TPaymentPlansResponse>({
    queryKey: getMemberPaymentPlansQueryKey(page, perPage),
    queryFn: async () => {
      const req = await axios.get(`${ENTITY}/payment-plans`, { params: { page, perPage } });
      return req.data;
    },
    enabled,
  });
};
